// Auto-generated by scripts/write-git-version.mjs
export const gitVersion = {
  "sha": "unknown",
  "branch": "unknown",
  "dirty": true,
  "buildTime": "2026-10-30T09:37:28.559Z"
};
export default gitVersion;
